"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _markdown = _interopRequireDefault(require("../markdown"));

var _svg = _interopRequireDefault(require("../svg"));

var _sections = require("./sections");

require("./collapsible-text.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-line

/**
 *
 * @param {Object} props
 * @param {String} props.className
 * @param {String} props.id
 * @param {Object} props.options Passed to Markdown renderer
 * @param {String} props.text
 * @param {String} props.title
 */
var CollapsibleText = function CollapsibleText(_ref) {
  var className = _ref.className,
      id = _ref.id,
      options = _ref.options,
      text = _ref.text,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "CollapsibleText ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    name: "accordionToggle",
    id: "row".concat(id),
    key: "input".concat(id),
    "aria-controls": "content".concat(id)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row",
    id: "content".concat(id),
    key: "content".concat(id),
    role: "tabpanel"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "titleText",
    htmlFor: "row".concat(id)
  }, /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    id: "chevron-bold"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text"
  }, title)), /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "content",
    source: text,
    options: options
  })));
};

CollapsibleText.propTypes = {
  id: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  options: _propTypes["default"].object // eslint-disable-line

};
CollapsibleText.defaultProps = {
  className: '',
  options: {
    html: true
  }
};
(0, _sections.registerWidget)('collapsibleTextSection', CollapsibleText);
var _default = CollapsibleText;
exports["default"] = _default;